import { useState } from "react";
import { pushSupported, pushEnabled, enablePush } from "../push";

export default function PushBanner() {
  const [hidden, setHidden] = useState(() => localStorage.getItem("push_banner_hidden") === "1");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(pushEnabled());
  if (hidden || done || !pushSupported() || Notification.permission === "denied") return null;

  const activate = async () => {
    setBusy(true);
    try { await enablePush(); setDone(true); }
    catch (e) { alert(e.message); }
    finally { setBusy(false); }
  };
  const dismiss = () => { localStorage.setItem("push_banner_hidden", "1"); setHidden(true); };

  return (
    <div className="panel" style={{ display: "flex", alignItems: "center", gap: 12, flexWrap: "wrap", padding: "10px 14px" }} data-testid="push-banner">
      <span style={{ fontSize: 13 }}>🔔 Vuoi il <b>numero di email da gestire e da approvare sull'icona dell'app</b> (anche ad app chiusa)?</span>
      <button className="btn sm primary" onClick={activate} disabled={busy} data-testid="push-enable-btn">{busy ? "Attivazione…" : "Attiva badge e notifiche"}</button>
      <button className="btn sm" onClick={dismiss} data-testid="push-dismiss-btn">Non ora</button>
    </div>
  );
}
